export function countNonNumericChars(value: string, upToPosition: number, useBlanksCorrection: boolean = false): number {
  if (!value) {
    return 0;
  }
  let nonNumericCount = 0;
  let blankCorrection = 0;
  for (let i = 0; i < upToPosition + blankCorrection; i++) {
    if (i < value.length - 1) {
      const charValue = value.charAt(i);
      const numCharValue = parseInt(charValue, 10);
      if (isNaN(numCharValue) && charValue !== '+') {
        nonNumericCount++;
        if (useBlanksCorrection) {
          blankCorrection++;
        }
      }
    }
  }
  return nonNumericCount;
}
